import { useCallback, useMemo } from "react"
import { useAppRegistrations } from "../../../../hooks/useAppRegistrations"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { AppRegistrationGet } from "../../../models/AppRegistration"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function AppRegistrations() {
  const { appRegistrationsList, isLoadingAppRegistrations } = useAppRegistrations()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/app-registrations",
    },
    { field: "clientId", headerName: "Client ID" },
  ]

  const sorted = [...appRegistrationsList].sort(
    (a: AppRegistrationGet, b: AppRegistrationGet) =>
      (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((appRegistration: AppRegistrationGet) => ({
    id: appRegistration.id,
    name: appRegistration.name,
    clientId: appRegistration.clientId,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/app-registrations/create"
        feature={DimaFeatureShortNameEnum.AR}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string; iconName?: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/appRegistrations/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingAppRegistrations}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
